import { render, staticRenderFns } from "./ModalZoomIframe.vue?vue&type=template&id=13815f04&"
import script from "./ModalZoomIframe.vue?vue&type=script&lang=js&"
export * from "./ModalZoomIframe.vue?vue&type=script&lang=js&"
import style0 from "./ModalZoomIframe.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports